module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_pp2_6005.fd9745a9.png";